import * as React from "react";
function SvgExams(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.252 19.97c-1.58 1.239-3.562 1.757-5.252 1.757s-3.672-.518-5.252-1.757C5.134 18.705 4 16.734 4 13.99c0-1.442.51-2.885 1.205-4.195.7-1.319 1.62-2.567 2.522-3.635a33.49 33.49 0 013.62-3.65l.001-.002h1.303l.002.001.087.074a30.874 30.874 0 011.053.956 33.5 33.5 0 012.48 2.621c.902 1.068 1.823 2.316 2.522 3.635C19.49 11.105 20 12.548 20 13.99c0 2.744-1.134 4.715-2.748 5.98zm-4.6-17.462a1.022 1.022 0 00-1.303 0h1.302zM12 4.56a31.537 31.537 0 00-2.727 2.834c-.848 1.004-1.677 2.135-2.29 3.292C6.364 11.85 6 12.977 6 13.99c0 2.164.866 3.575 2.003 4.465 1.169.917 2.687 1.326 3.997 1.326s2.828-.41 3.998-1.326C17.134 17.565 18 16.154 18 13.99c0-1.013-.365-2.14-.982-3.303-.614-1.157-1.443-2.288-2.29-3.292A31.511 31.511 0 0012 4.56z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgExams);
export default ForwardRef;
